import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ProfessionalConceptService } from '../../../../../services/professional-concept/professional-concept.service';
import { ProfessionalConceptDto } from '../../../../../models/professional-concept/professional-concept-dto';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';

export class StaffDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<ProfessionalConceptDto[]> = new BehaviorSubject<ProfessionalConceptDto[]>([]);

    constructor(
        private professionalConceptService: ProfessionalConceptService,
        private shifts: any[],
        private schoolYearId: number,
        onDataLoaded?: any,
    ) {
        setTimeout(() => {
            this.professionalConceptService.getAll(this.schoolYearId).subscribe(response => {
                console.log('StaffDatabase > response', response);
                for (const r of response) {
                    // this.shifts.forEach(shift => {
                    //     const found = r.Shifts.find(s => s.ShiftId === shift.Id);
                    //     r[shift.Id] = found ? found.ConceptId : null;
                    // });
                    this.add(r);
                }
                if (onDataLoaded) {
                    onDataLoaded();
                }
                console.log('result>>>>>>>>>', this.data);

            }, error => {

            });
        }, 100);
    }

    get data(): ProfessionalConceptDto[] {
        return this.dataChange.value;
    }

    public add(store: ProfessionalConceptDto) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: ProfessionalConceptDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: ProfessionalConceptDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/professional-concept/edit-professional-concept/staff-database.ts